export const NAME_MAX_LENGTH = 20;

// Буквы любого алфавита; пробел, дефис и апостроф допустимы только между буквами.
// RegExp-конструктор вместо литерала: флаг "u" недоступен при target es5.
const NAME_PATTERN = new RegExp("^\\p{L}+(?:[ '-]\\p{L}+)*$", "u");

export const validateUserName = (value: string): string | null => {
  const name = value.trim();

  if (!name) return "This field is required.";
  if (name.length > NAME_MAX_LENGTH) {
    return `Must be at most ${NAME_MAX_LENGTH} characters.`;
  }
  if (!NAME_PATTERN.test(name)) {
    return "Use letters only; spaces, hyphens and apostrophes between letters.";
  }
  return null;
};
